import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import PriceCalc from './PriceCalc.js';
// import './pricing.css';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';



import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  button: {
    margin: theme.spacing.unit,
    // boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    // fontWeight:'800',
    padding: '3px 6px',
    border: '1px solid',
    color: 'white',
    // lineHeight: 1.5,
    backgroundColor: 'rgb(114, 165,199)',
    borderColor: 'rgb(114, 165,199)',
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
    '&:hover': {
      backgroundColor: '#203b60',
      borderColor: '#203b60',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#0062cc',
      borderColor: '#005cbf',
    },
  },
  textField: {
    // marginLeft: theme.spacing.unit,
    // marginRight: theme.spacing.unit,
    // width: 200,
    textAlign: "center",
    color: "#203b60",

    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  root: {
    padding: 0,
    marginBottom: '1px'


  },
});

class InfoDialog extends Component {

  constructor(props) {
    super(props);
    this.state = {
      users: 0,
      total_month: 0,
      plan_names: [],
      checkedPlan: "Gold Plus"
    }
    this.handleClose = this.handleClose.bind(this)

  }

  handleClose() {
    this.props.close()
  }



  render() {
    const { classes } = this.props;
    const { fullScreen } = this.props;

    return (
      <React.Fragment>

        <Dialog
          fullScreen={fullScreen}
          open={this.props.open}
          onClose={this.handleClose}
          scroll="paper"
          aria-labelledby="responsive-dialog-title"
        >


          <DialogTitle disableTypography={true} id="responsive-dialog-title">
          <div className="pricing-title">{this.props.data.name}</div>
          </DialogTitle>


          <DialogContent>
            <DialogContentText>
              {this.props.data.description}
            </DialogContentText>
          </DialogContent>
          <DialogActions>

            <Button onClick={this.handleClose} color="primary" autoFocus>
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>

      </React.Fragment>


    );
  }
}


InfoDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool.isRequired,

};

export default withStyles(styles)(withMobileDialog()(InfoDialog));
// export default AppsGrid;